export const JWT_KEY = 'JWT'
export const EDIT_USER_ID_KEY = "EDIT_USER_ID"
export const LOOKUPS_KEY = 'LOOKUPS'
export const RESUME_KEY = 'RESUME'